"use client";

import { useQuery } from "@tanstack/react-query";
import { StoryblokStory } from "@trydig/storyblok";
import { rpc } from "#rpc";
import { Translate } from "@/components/Translate";
import { useLocale, useTranslations } from "@/i18n/client";

/**
 * Why is this client you ask?
 * Because Next.js IS broken and somehow renders this page on EVERY page load causing massive unnecessary load on Storyblok + Cache tagging. Bravo Vercel.
 */

const NotFound = () => {
	const [locale] = useLocale();
	const t = useTranslations();
	const { data, error, isLoading } = useQuery({
		queryKey: ["not-found", locale],
		queryFn: async () => {
			return rpc.stories.notFound(locale);
		},
	});

	if (!data && !error || isLoading) {
		return <div style={{ height: "100vh" }} />;
	}

	if (error || !data) {
		return (
			<div>
				<title>{t("Can't find the page - 404")}</title>
				<h1>
					<Translate>Oops. Could not find you a page.</Translate>
				</h1>
			</div>
		);
	}

	return (
		<>
			<title>{t("Can't find the page - 404")}</title>
			<StoryblokStory preview story={data} />
		</>
	);
};

export default NotFound;
